/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import React, { useEffect, useRef, useState, useMemo } from "react";
import clsx from "clsx";
import {
  Popover,
  LinearProgress,
  makeStyles,
  TablePagination,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { AutoSizer, List } from "react-virtualized";
import PropTypes from "prop-types";
import styles from "./Table.module.css";
import { columnsPropType } from "../../types";
import { TableRow, TableHead, SelectionMenu } from "../../atomicComponents";
import GridLoadingSpinner from "../GridLoadingSpinner/GridLoadingSpinner";
// import { getCutomiseTableButton } from "../../redux/selectors/customiseTableButtonSelector";
// import { hideCustomiseTableButton } from "../../redux/features/customise-table-button/actions";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: theme.palette.primary.primaryBlue,
    },
  },
}));

const Table = ({
  rows: data,
  classNames = {},
  rowHeight = 75,
  headerHeight,
  columns: originalColumns,
  defaultColumns: originalDefaultColumns,
  setHasActiveEdits,
  isDataLoading,
  hideCheckbox,
  selectedRows = () => {},
  // eslint-disable-next-line no-unused-vars
  fetchDataCallback,
  serverSide = false,
  totalRows = 0,
  page = 0,
  rowsPerPage = 10,
  onPageChange = () => {},
  onRowsPerPageChange = () => {},
}) => {
  const [rowsData, setRowsData] = useState({
    data: [...data],
    filteredData: [...data],
  });
  const dispatch = useDispatch();
  // const {
  //   isButtonClicked: isCustomizeTableMenuOpen,
  //   buttonRef: customizeTableButtonRef,
  // } = useSelector(getCutomiseTableButton);

  const handleColumnSelectionChange = (columnTitle) => {
    if (selectedColumns.map(({ title }) => title).includes(columnTitle))
      return setSelectedColumns((prev) =>
        prev.filter((column) => column.title !== columnTitle)
      );
    return setSelectedColumns((prev) => [
      ...prev,
      ...originalColumns.filter(({ title }) => title === columnTitle),
    ]);
  };

  const applyColumnsSelections = (columnSelections) => {
    setSelectedColumns([
      ...defaultColumns.slice(
        0,
        defaultColumns.length - originalDefaultColumns.length
      ),
      ...originalColumns.filter((col) => columnSelections.includes(col.title)),
    ]);
  };

  const classes = useStyles();
  const [fieldToSearchTextMap, setFieldToSearchTextMap] = useState({});
  const [isEllipsisPopupOpen, setIsEllipsisPopupOpen] = useState(false);
  const [ellipsisAnchorEl, setEllipsisAnchorEl] = useState(null);
  const [ellipsisPopupValue, setEllipsisPopupValue] = useState(null);
  const [fieldToFiltersSetMap, setFieldToFiltersSetMap] = useState({});
  const closeEllipsisPopup = () => setIsEllipsisPopupOpen(false);

  const tableHeadRef = useRef(null);

  const handleListScroll = (e) =>
    (tableHeadRef.current.scrollLeft = e.target.scrollLeft);

  const listRef = useRef(null);

  useEffect(() => {
    // eslint-disable-next-line consistent-return
    const attachScrollListener = () => {
      if (listRef.current && listRef.current.Grid) {
        // eslint-disable-next-line no-underscore-dangle
        const gridElement = listRef.current.Grid._scrollingContainer;
        if (gridElement && tableHeadRef.current) {
          const handleScroll = (e) => {
            tableHeadRef.current.scrollLeft = e.target.scrollLeft;
          };

          gridElement.addEventListener("scroll", handleScroll);
          return () => gridElement.removeEventListener("scroll", handleScroll);
        }
      }
    };

    const cleanup = attachScrollListener();
    return cleanup;
  }, [rowsData.filteredData.length, serverSide, isDataLoading]);

  const handlePopoverOpen = (event, val) => {
    if (event.currentTarget.scrollWidth > event.currentTarget.clientWidth) {
      setEllipsisPopupValue(val);
      setIsEllipsisPopupOpen(true);
      setEllipsisAnchorEl(event.currentTarget);
    }
  };

  const handlePopoverClose = () => {
    setIsEllipsisPopupOpen(false);
    setEllipsisAnchorEl(null);
  };

  const toggleSelectAllRows = () => {
    setRowsData((prev) => {
      const visibleRowIdsSet = new Set(prev.filteredData.map((row) => row.id));
      const isSelected = !prev.filteredData.every((row) => row.isSelected);
      return {
        ...prev,
        filteredData: prev.filteredData.map((row) => ({ ...row, isSelected })),
        data: prev.data.map((row) => {
          if (visibleRowIdsSet.has(row.id)) return { ...row, isSelected };
          return row;
        }),
      };
    });
  };

  const handleRowSelection = (selectedId) =>
    setRowsData((prev) => ({
      ...prev,
      data: prev.data.map((row) => {
        return row.id === selectedId
          ? { ...row, isSelected: !row.isSelected }
          : row;
      }),
      filteredData: prev.data.map((row) => {
        return row.id === selectedId
          ? { ...row, isSelected: !row.isSelected }
          : row;
      }),
    }));

  useEffect(() => {
    selectedRows(rowsData.data.filter((row) => row.isSelected));

    if (setHasActiveEdits) {
      const areEditsActive = rowsData.data.some((row) => row.isSelected);
      setHasActiveEdits(areEditsActive);
    }
  }, [rowsData.data, setHasActiveEdits]);

  const defaultColumns = useMemo(
    () => {
      return [
        // {
        //   title: "#",
        //   field: "_serialNumber",
        //   width: 54,
        //   render: (_, idx) => idx,
        //   renderHeader: (rows) =>
        //     displayHash ? (
        //       "#"
        //     ) : (
        //       <div className={{}} data-testid="count">
        //         {displayHash ? "#" : rows?.length || 0}
        //       </div>
        //     ),
        //   headerStyles: {
        //     paddingLeft: 7,
        //     paddingRight: 2,
        //   },
        // },
        !hideCheckbox
          ? {
              title: "select",
              field: "_select",
              width: 60,
              // eslint-disable-next-line arrow-body-style
              renderHeader: (rows) => {
                return (
                  <input
                    style={{ marginTop: 0 }}
                    type="checkbox"
                    onChange={toggleSelectAllRows}
                    checked={
                      rows?.length && rows.every((row) => row.isSelected)
                    }
                  />
                );
              },
              render: ({ isSelected, id }) => (
                <input
                  style={{ marginTop: 0, marginBottom: 0 }}
                  type="checkbox"
                  onChange={() => handleRowSelection(id)}
                  checked={!!isSelected}
                  data-testid={`select-row-${id}`}
                  id={`select-row-${id}`}
                  name={`select-row-${id}`}
                />
              ),
            }
          : null,
        ...originalDefaultColumns,
      ].filter((i) => i);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [originalDefaultColumns, styles]
  );
  const [selectedColumns, setSelectedColumns] = useState(defaultColumns);

  const noOfFixedColumns = originalDefaultColumns?.length + 1;

  const [showCopyAlert, setShowCopyAlert] = useState(false);

  const reorder = (list, startIndex, endIndex) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };
  const isRowLoaded = ({ index }) => !!rowsData.data[index];
  const loadMoreRows = ({ startIndex, stopIndex }) =>
    new Promise((resolve) => {
      setTimeout(async () => {
        await fetchDataCallback(startIndex, stopIndex);
        resolve();
      }, 1000);
    });
  useEffect(() => {
    setRowsData({
      data: [...data],
      filteredData: [...data],
    });
  }, [data]);

  useEffect(() => {
    setRowsData((prevState) => {
      const dataFilteredBySearchTexts = filterBySearchTexts(
        fieldToSearchTextMap,
        prevState.data,
        selectedColumns
      );

      const dataFilteredBySearchAndFilters = filterBySelectedFilters(
        fieldToFiltersSetMap,
        dataFilteredBySearchTexts,
        selectedColumns
      );

      return { ...prevState, filteredData: dataFilteredBySearchAndFilters };
    });
  }, [
    selectedColumns,
    fieldToFiltersSetMap,
    fieldToSearchTextMap,
    rowsData.data,
  ]);

  useEffect(() => {
    if (showCopyAlert) setShowCopyAlert(false);
  }, [showCopyAlert]);

  useDeepCompareColumnArraysEffect(() => {
    setSelectedColumns(defaultColumns);
  }, [defaultColumns]);

  const reorderHeaders = (result) => {
    // dropped outside the list or dropped at serial number place
    if (!result.destination || result.destination.index < noOfFixedColumns) {
      return;
    }

    const reorderedColumns = reorder(
      selectedColumns,
      result.source.index,
      result.destination.index
    );

    setSelectedColumns(reorderedColumns);
  };

  const rowRenderer = ({ style, index, key }) => {
    const handleCopy = (text) => {
      navigator.clipboard.writeText(text);
      setShowCopyAlert(true);
    };

    return (
      <TableRow
        index={index}
        style={style}
        key={key}
        row={rowsData.filteredData[index]}
        columns={selectedColumns}
        classNames={{ ...classNames }}
        rowHeight={rowHeight}
        onCopy={handleCopy}
        handlePopoverOpen={handlePopoverOpen}
        handlePopoverClose={handlePopoverClose}
      />
    );
  };

  const handleChangePage = (event, newPage) => {
    onPageChange(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onRowsPerPageChange(parseInt(event.target.value, 10));
  };

  return (
    <>
      <div
        style={{ width: "100%", height: "100%", position: "relative" }}
        className={clsx(
          styles.baseContainer,
          classNames.tableContainerClassName
        )}
      >
        <div
          style={{ width: "100%", height: "100%" }}
          className={clsx(
            styles.basicTableContainer,
            classNames.tableContainerClassName
          )}
        >
          <AutoSizer>
            {({ width: windowWidth, height: windowHeight }) => {
              const width = windowWidth;
              const height = windowHeight - (serverSide ? 56 : 0); // Adjust height for pagination
              const listHeight = height - rowHeight - 2;
              return (
                <div
                  className={clsx(styles.basicTable, classNames.tableClassName)}
                  style={{
                    height: windowHeight,
                    width,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <TableHead
                    columns={selectedColumns}
                    ref={tableHeadRef}
                    className={classNames.tableHeadClassName}
                    height={headerHeight || rowHeight}
                    reorderHeaders={reorderHeaders}
                    rows={rowsData.filteredData}
                    allRows={rowsData.data}
                    fieldToSearchTextMap={fieldToSearchTextMap}
                    setSearchTextForTitleCurry={(field) => (value) =>
                      setFieldToSearchTextMap((prev) => ({
                        ...prev,
                        [field]: value.toLowerCase(),
                      }))}
                    noOfFixedColumns={noOfFixedColumns}
                    fieldToFiltersSetMap={fieldToFiltersSetMap}
                    setFiltersForFieldCurry={(field) => (selectedFilters) =>
                      setFieldToFiltersSetMap((prev) => ({
                        ...prev,
                        [field]: new Set(selectedFilters),
                      }))}
                    style={{ display: "flex", alignItems: "center" }}
                  />
                  {isDataLoading ? (
                    <div className={styles.spinnerContainer}>
                      <GridLoadingSpinner />
                    </div>
                  ) : (
                    <List
                      ref={listRef}
                      containerStyle={{ overflow: "initial" }}
                      rowRenderer={rowRenderer}
                      height={listHeight}
                      rowHeight={rowHeight}
                      rowCount={rowsData.filteredData.length}
                      width={width}
                      className={clsx(
                        styles.scrollBar,
                        styles.heightAdjustedListScroll
                      )}
                      overscanRowCount={10}
                    />
                  )}

                  {serverSide && (
                    <TablePagination
                      component="div"
                      className={styles.pagination}
                      count={totalRows}
                      page={page}
                      onChangePage={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  )}
                </div>
              );
            }}
          </AutoSizer>
        </div>
      </div>
      <SelectionMenu
        // anchorEl={customizeTableButtonRef?.current}
        // open={isCustomizeTableMenuOpen}
        // handleClose={() => {
        //   dispatch(hideCustomiseTableButton());
        // }}
        options={originalColumns.map(({ title }) => title)}
        currentSelections={selectedColumns
          .filter(({ title }) => title !== "select" && title !== "#")
          .map(({ title }) => title)}
        handleChange={handleColumnSelectionChange}
        resetToDefault={() => setSelectedColumns([...defaultColumns])}
        applySelections={applyColumnsSelections}
        defaultColumns={defaultColumns.map(({ title }) => title)}
      />
      <Popover
        open={isEllipsisPopupOpen}
        anchorEl={ellipsisAnchorEl}
        onClose={closeEllipsisPopup}
        className={styles.popover}
        classes={{
          paper: styles.popoverPaper,
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {ellipsisPopupValue}
      </Popover>
      <div
        className={clsx(
          styles.copyAlert,
          showCopyAlert ? styles.visible : styles.hidden
        )}
      >
        Text copied
      </div>
    </>
  );
};

Table.propTypes = {
  classNames: PropTypes.shape({
    tableContainerClassName: PropTypes.string,
    tableClassName: PropTypes.string,
    tableRowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    tableHeadClassName: PropTypes.string,
  }),
  rowHeight: PropTypes.number,
  headerHeight: PropTypes.number,
  defaultColumns: columnsPropType,

  setHasActiveEdits: PropTypes.func,
  isDataLoading: PropTypes.bool,
  hideCheckbox: PropTypes.bool,
  selectedRows: PropTypes.func,
  serverSide: PropTypes.bool,
  totalRows: PropTypes.number,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
};

export default Table;

function filterBySearchTexts(fieldToSearchTextMap, data, columns) {
  const fieldToSearchFnMap = columns.reduce((acc, col) => {
    if (col.searchFn) return { ...acc, [col.field]: col.searchFn };
    return acc;
  }, {});

  let filteredData = [...data];

  Object.entries(fieldToSearchTextMap).forEach(([field, searchText]) => {
    if (!searchText) return;

    const defaultSearchFn = (fieldValue, searchValue) =>
      fieldValue?.toLowerCase().includes(searchValue);

    const searchFn = fieldToSearchFnMap[field] || defaultSearchFn;

    filteredData = filteredData.filter(
      (row) => row[field] && searchFn(row[field], searchText)
    );
  });

  return filteredData;
}

function filterBySelectedFilters(fieldToFiltersSetMap, data, columns) {
  const fieldToFilterFnMap = columns.reduce((acc, col) => {
    if (col.filterFn) return { ...acc, [col.field]: col.filterFn };
    return acc;
  }, {});

  let filteredData = [...data];
  Object.entries(fieldToFiltersSetMap).forEach((entry, idx) => {
    const [field, filtersSet] = entry;
    const filterFn = fieldToFilterFnMap[field];

    filteredData = filteredData.filter((row) => {
      if (!filterFn) return !filtersSet?.size || filtersSet.has(row[field]);
      if (!idx) {
        console.log(" [...filtersSet]", [...filtersSet]);
      }

      return (
        !filtersSet?.size ||
        [...filtersSet].some((filter) => filterFn(row, filter.value))
      );
    });
  });
  return filteredData;
}

function deepCompareEqualsColumnsArray(oldArray, newArray) {
  if (oldArray?.length !== newArray?.length) return false;
  const zippedArray = oldArray.map((e, i) => [e, newArray[i]]);
  return zippedArray.every((tuple) => tuple[0].title === tuple[1].title);
}

function useDeepCompareColumnArraysMemoize(value) {
  const ref = useRef();
  if (!deepCompareEqualsColumnsArray(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

function useDeepCompareColumnArraysEffect(callback, dependencies) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, dependencies.map(useDeepCompareColumnArraysMemoize));
}
